const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('pages/B2C')
      },
      {
        path: '/referenzen',
        name: 'References',
        component: () => import('pages/References')
      },
      {
        path: '/insights',
        name: 'Insights',
        component: () => import('pages/Insights')
      },
      {
        path: '/glossary',
        name: 'Glossary',
        component: () => import('pages/Terms.vue')
      },
      {
        path: '/referenzen/:url',
        name: 'Reference',
        props: true,
        component: () => import('pages/Reference')
      },
      {
        path: '/blogs/:slug',
        name: 'Blog',
        props: true,
        component: () => import('pages/Blog')
      },
      {
        path: '/b2c/analyzer',
        name: 'B2C Analyzer',
        component: () => import('pages/B2CAnalyzer')
      },
      {
        path: '/b2b/analyzer',
        name: 'B2B Analyzer',
        component: () => import('pages/B2BAnalyzer')
      },
      {
        path: '/solutions',
        name: 'Solutions',
        component: () => import('pages/Solutions.vue')
      },
      {
        path: '/blogs',
        name: 'Blogs',
        component: () => import('pages/Blogs.vue')
      },
      {
        path: '/details-report',
        name: 'DetailsReport',
        props: true,
        component: () => import('pages/WebDetailsReport')
      },
      {
        path: '/about-us',
        name: 'About Us',
        component: () => import('pages/AboutUs.vue')
      },
      {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        component: () => import('#/pages/PrivacyPolicy')
      },
      {
        path: '/terms-and-conditions',
        name: 'Terms and Conditions',
        component: () => import('#/pages/TermsAndConditions')
      },
      {
        path: '/impressum',
        name: 'Impressum',
        component: () => import('pages/Impressum')
      }
    ]
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
